export default __webpack_public_path__ + "static/media/image1.29b30eac.png";